import { useEffect, useState } from "react"
import { motion } from "framer-motion"
import QRCode from "qrcode"

interface QRCodeCardProps {
  url: string
  label: string
  platform: "ios" | "android"
}

export function QRCodeCard({ url, label, platform }: QRCodeCardProps) {
  const [qrImage, setQrImage] = useState<string>("")

  useEffect(() => {
    QRCode.toDataURL(url, {
      errorCorrectionLevel: "H",
      type: "image/png",
      quality: 0.95,
      margin: 1,
      width: 200,
      color: {
        dark: "#000000",
        light: "#FFFFFF",
      },
    }).then(setQrImage)
  }, [url])

  return (
    <motion.div
      className="flex flex-col items-center gap-3"
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.3 }}
    >
      <div className="relative">
        {qrImage && (
          <motion.img
            src={qrImage}
            alt={`${label} QR Code`}
            className="w-40 h-40 border-4 border-blue-600 rounded-lg"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          />
        )}
        <motion.div
          className="absolute inset-0 border-4 border-blue-600 rounded-lg"
          animate={{
            boxShadow: ["0 0 0 0 rgba(37, 99, 235, 0.7)", "0 0 0 10px rgba(37, 99, 235, 0)"],
          }}
          transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY }}
        />
      </div>
      <p className="text-sm font-medium text-gray-300">{label}</p>
    </motion.div>
  )
}
